import { Component, ChangeDetectorRef} from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';
import { PrintRoutePlanner } from 'src/app/core/events/print-events';
import { RoutePlannerPrintService } from '../../services/route-planner-print/route-planner-print.service';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';

@Component({
    selector: 'route-planner-print-view',
    templateUrl: './route-planner-print-view.component.html',
    styleUrls: ['./route-planner-print-view.component.scss'],
    standalone: false
})
export class RoutePlannerPrintViewComponent {

  public openPrintModal = false;
  public mapSettings: any;

  constructor(private eventsService: EventsService,
    private appRouterDataService: AppRouterDataService,
    private routePrintService: RoutePlannerPrintService,
    private cdr: ChangeDetectorRef) {
      console.log('*********** Preview Preview Loading ***********');
      this.mapSettings = this.routePrintService.printModel.MapSettings;
      this.openPrintModal = true;
      this.apply();
  }

  public closeModel() {
    this.eventsService.dispatch(PrintRoutePlanner.CLOSE_PRINT_PREVIEW);
    this.openPrintModal = false;
    this.appRouterDataService.updateURL(AARouterURL.PRINT_PREVIEW_CLOSE);
  }

  public printMap(): void {
    this.routePrintService.print();
  }

  private apply(): void {
    setTimeout( () => {
      this.cdr.detectChanges();
    }, 10);
  }
}
